<section class="menu-access-detail menu-access-detail--nested">
    <div class="menu-access-detail-header">
        <div>
            <p class="menu-access-detail-eyebrow">Role Access</p>
            <h2>Sub Sub Menu Role Access</h2>
        </div>
    </div>

    <ag-grid-angular
        class="ag-theme-ulaap menu-access-detail-grid"
        (gridReady)="onGridReady($event)"
        [defaultColDef]="defaultColDef"
        [columnDefs]="subSubMenuColumnDefs"
        [rowData]="sub_sub_menu_items"
        [rowHeight]="42"
        [headerHeight]="44">
    </ag-grid-angular>
</section>
